<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Vevői eladások - Szállítólevelek</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/sales/customer-sales/add')"
        icon="el-icon-plus"
        v-can="'customersale.create'"
      >
        Új vevői eladás
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="customerSale/fetchAll"
      />
    </div>
    <customer-sale-list/>
    <template v-if="$route.meta.showAddCustomerSaleDialog">
      <customer-sale-dialog
        :customerSaleId="$route.params.id"
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateCustomerSaleDialog">
      <customer-sale-dialog
        :customerSaleId="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showCustomerSaleViewDialog">
      <customer-sale-dialog
        :customerSaleId="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
  import customerSaleList from '../../components/sales/customerSales/List';
  import customerSaleDialog from '../../components/sales/customerSales/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      customerSaleList,
      customerSaleDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'text',
            name: 'cm_delivery_note_number',
            label: 'CM szlev szám',
          },
          {
            type: 'text',
            name: 'stowage',
            label: 'Rakodási lista',
          },
          {
            type: 'text',
            name: 'invoice',
            label: 'Számlaszám',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Igen',
                hasInvoice: 1
              },
              {
                label: 'Nem',
                hasInvoice: 0
              },
            ],
            name: 'has_invoice',
            label: 'Van számla',
            labelCallback: status => status.label,
            valueKey: 'hasInvoice',
          },
          {
            type: 'text',
            name: 'customer_order',
            label: 'Megrendelés',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Rögzítve',
                status: 'recorded'
              },
              {
                label: 'Teljesítve',
                status: 'done'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Igen',
                isBillable: 1
              },
              {
                label: 'Nem',
                isBillable: 0
              },
            ],
            name: 'is_billable',
            label: 'Számlázandó',
            labelCallback: status => status.label,
            valueKey: 'isBillable',
          },
          {
            type: 'remote',
            name: 'customer_id',
            label: 'Vevő',
            labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'partner/search',
          },
        ];
      },
    },
  };
</script>
